import React, { useState, useEffect, useRef } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector, useDispatch } from "react-redux";
import CreateCourse from "components/CourseBuilder/CreateCourse/CreateCourse";
import TeamCourseLists from "components/CourseBuilder/TeamCourseLists/TeamCourseLists";
import { useTeamContext } from "store/contexts/teamContext";
import { CourseContext } from "store/contexts/courseContext";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import * as timelineActions from "reteamStore/actions";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import FilterCourseBuilder from "components/CourseBuilder/FilterCourseBuilder/FilterCourseBuilder";

export default () => {
  const { team } = useTeamContext();
  const { getAllCourses } = useTeamActionContext();
  const dispatch = useDispatch();
  const { total, page, isLoading, courses } = useSelector(
    (state) => state.courseReducer
  );
  const [order_by, setOrderBy] = useState("oldest");
  const [status_id, setStatusId] = useState(null);
  const isInitialMount = useRef(true);
  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  const createCourse = (course) => {
    if (!course) {
      return;
    }

    dispatch(timelineActions.createCourse(course));
  };

  const updateCourse = (course) => {
    dispatch(timelineActions.updateCourse(course));
  };

  const getNextPageData = () => {
    getAllCourses(page + 1, order_by, status_id);
    dispatch(timelineActions.coursePageIncreament());
  };

  const setTimelineCourses = () => {
    dispatch(timelineActions.clearAllCourses());
  };

  const setPage = () => {
    // Reset page in redux to page 1
    dispatch(timelineActions.clearAllCourses());
    // Set the internal page counter to 1
    for (let i = page; i > 1; i--) {
      dispatch(timelineActions.coursePageIncreament());
    }
  };

  // Add useEffect to react to filter changes
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    
    const fetchCourses = () => {
      if (getAllCourses) {
        getAllCourses(1, order_by, status_id);
      }
    };
    
    fetchCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_by, status_id]);

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} />
        </h4>
      )}
      {!isLoading && (
        <h4>
          <Button onClick={getNextPageData}>Load More</Button>
        </h4>
      )}
    </>
  );

  return (
    <CourseContext.Provider
      value={{
        createCourse,
        updateCourse,
      }}
    >
      <div className="py-4">
        <div className="tasks-btn mb-3">
          <CreateCourse team={team} />
          <FilterCourseBuilder
            setStatusId={setStatusId}
            setPage={setPage}
            setIsLoading={(value) => dispatch(timelineActions.setCourseLoader(value))}
            setTimelineCourses={setTimelineCourses}
            setOrderBy={setOrderBy}
            order_by={order_by}
            status_id={status_id}
          />
        </div>
        <InfiniteScroll
          style={{ overflow: "hidden" }}
          dataLength={total ?? 0}
          next={getNextPageData}
          hasMore={courses.length !== total}
          loader={LoadingContainer}
          scrollableTarget="main-panel-right"
          endMessage={
            <div style={{ textAlign: "center" }}>
              {total > 0 && <div>Yay! You have seen it all</div>}
            </div>
          }
        >
          <TeamCourseLists courses={courses} total={total} />
        </InfiniteScroll>
      </div>
    </CourseContext.Provider>
  );
}; 